import { QueryClient, useQueryClient } from "@tanstack/react-query";
import { trpc } from "components/rpc/trpc";
import { useCallback } from "react";
import {
    QueryClient as LegacyQueryClient,
    useQueryClient as useLegacyQueryClient,
} from "react-query";

type AgendaTrpcClient = ReturnType<typeof trpc.useTRPC>;

const agendaQueryKeys = (trpcClient: AgendaTrpcClient) => [
    trpcClient.marketingPlaybook.myAgenda.queryKey(),
    trpcClient.marketingPlaybook.activeSnoozes.queryKey(),
    trpcClient.calendarEvents.listForCalendar.queryKey(),
    trpcClient.calendarEvents.listUpcomingByParent.queryKey(),
    trpcClient.calendarEvents.listByParent.queryKey(),
    trpcClient.calendarEvents.listByBusiness.queryKey(),
    trpcClient.marketingPlaybook.contactPlan.queryKey(),
    trpcClient.marketingPlaybook.orgPlan.queryKey(),
    trpcClient.recentActivity.forEntity.queryKey(),
    trpcClient.touchpoint.myActivity.queryKey(),
    trpcClient.homeCareLeadPartnerSend.sends.queryKey(),
];

const legacyQueryKeys = [
    "getActivityFeed",
    "getNotesForEntity",
    "getTasksForEntity",
    "getTasksv2",
    "getTasks",
    "getReminders",
];

export const invalidateAgendaQueries = async (
    trpcClient: AgendaTrpcClient,
    queryClient: QueryClient,
    legacyQueryClient: LegacyQueryClient,
): Promise<void> => {
    await Promise.all([
        ...agendaQueryKeys(trpcClient).map(queryKey =>
            queryClient.invalidateQueries({ queryKey }),
        ),
        ...legacyQueryKeys.map(queryKey => legacyQueryClient.invalidateQueries(queryKey)),
    ]);
};

export const useAgendaRefresh = () => {
    const trpcClient = trpc.useTRPC();
    const queryClient = useQueryClient();
    const legacyQueryClient = useLegacyQueryClient();
    return useCallback(
        () => invalidateAgendaQueries(trpcClient, queryClient, legacyQueryClient),
        [trpcClient, queryClient, legacyQueryClient],
    );
};
